import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { SegmentCategory, SegmentPageName, segmentPageTracking } from '../segment'
import { PATH_URL } from '../path'

export function useSegmentPage() {
  const location = useLocation()
  useEffect(() => {
    const locationListener = () => {
      const url = (() => {
        try {
          return window.location.href
        } catch {
          return ''
        }
      })()

      if (url.includes('import-pins')) {
        segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.IMPORT_PINS, { url })
        return
      }

      switch (location.pathname) {
        case PATH_URL.EXISTING_PROPOSAL:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.EXISTING_PROPOSAL, {
            url,
          })
          break
        case PATH_URL.QUIZ_END:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.QUIZ_END, { url })
          break
        case PATH_URL.YOUR_POPPY_PROPOSAL:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.YOUR_POPPY_PROPOSAL, {
            url,
          })
          break
        case PATH_URL.CALL_SCHEDULED:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.CALL_SCHEDULED, { url })
          break
        case PATH_URL.$500_CUSTOMER:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.$500_CUSTOMER, { url })
          break
        case PATH_URL.SCHEDULE_YOUR_CONSULTATION:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.SCHEDULE_YOUR_CONSULTATION, {
            url,
          })
          break
        case PATH_URL.MOODBOARD:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.MOODBOARD, { url })
          break
        case PATH_URL.POST_MOODBOARD:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.POST_MOODBOARD, { url })
          break
        case PATH_URL.SCHEDULE_A_CALL:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.SCHEDULE_A_CALL, {
            url,
          })
          break

        case PATH_URL.NEW_COLOR_PALETTE_PAGE:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.MO_COLOR_PALETTE_PAGE, {
            url,
          })
          break

        case PATH_URL.NEW_AVAILABILITY_PAGE:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.MO_AVAILABILITY_PAGE, {
            url,
          })
          break

        case PATH_URL.YOUR_DETAILS:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.MO_DETAILS, {
            url,
          })
          break

        case PATH_URL.PLANNING_STAGE:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.MO_PLANNING_STAGE, {
            url,
          })
          break

        case PATH_URL.GUEST_COUNT:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.MO_GUEST_COUNT, {
            url,
          })
          break

        case PATH_URL.NEW_BUDGET_PAGE:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.MO_BUDGET_PAGE, {
            url,
          })
          break

        case PATH_URL.ESSENTIALS_COLLECTION_PAGE:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.MO_ESSENTIALS_COLLECTION_PAGE, {
            url,
          })
          break

        case PATH_URL.CONTACT_INFO:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.MO_CONTACT_INFO, {
            url,
          })
          break

        case PATH_URL.PINTEREST_AVAILABILITY:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.PINTEREST_AVAILABILITY, {
            url,
          })
          break

        case PATH_URL.PINTEREST_BOARD:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.PINTEREST_BOARD, {
            url,
          })
          break

        case PATH_URL.PINTEREST_LINK_YOUR_BOARD:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.PINTEREST_LINK_YOUR_BOARD, {
            url,
          })
          break

        case PATH_URL.BUDGET_PLANNER:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.BUDGET_PLANNER, {
            url,
          })
          break

        default:
          segmentPageTracking(SegmentCategory.STYLE_QUIZ, SegmentPageName.UNKNOWN, { url })
          break
      }
    }

    locationListener()
  }, [location])
}
